import { useCallback } from 'react';

import { config } from '@/config/config';
import { openAuthorizeUrl } from '@/modules/integrations/openAuthorizeUrl';

/**
 * Returns a handler that starts the server-owned Google Calendar OAuth flow.
 * It runs in the current tab: the API callback returns to
 * `/hm/integrations?calendarConnection=success|failure`.
 */
export const useConnectGoogleCalendar = () => {
  return useCallback(() => {
    const authorizeEndpoint = new URL(
      '/calendar/oauth/authorize',
      config.app.apiBaseUrl,
    );
    authorizeEndpoint.searchParams.set('source', 'HiringManager');

    openAuthorizeUrl(authorizeEndpoint.toString());
  }, []);
};
